// extracted by mini-css-extract-plugin
export default {"projectContainer":"haveProject_projectContainer__Bttpg","project":"haveProject_project__hjLbN","project-arrow":"haveProject_project-arrow__VTg6O"};